import { render, staticRenderFns } from "./MainSectionJobSearch.vue?vue&type=template&id=154afa24&"
import script from "./MainSectionJobSearch.vue?vue&type=script&lang=js&"
export * from "./MainSectionJobSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports